import React from "react";
import { Item } from "./Yuyue";
import styles from "../css/Yuyue.css";
import selfStyles from "../css/Fp.css";
import { request } from "../request";
import { Header } from "./Introduce";
import { getId } from "./ReceivingInformation";
import { Button, Toast } from "antd-mobile";
import teststyles from "../css/test.css";
import { uploadOSS, checkFileName } from "../tools/uploadFile";

import {
  Img,
  checkChineseP,
  CheckSocialCreditCodeOrg,
  Loading,
} from "../tools/wechatBrower";
import _ from "lodash";


export default class extends React.Component {
  state = {
    model: "",
    data: {
      default: {},
      info: [],
    },
    type: "普票",
    uploaedImages: [],
    phone: "",
    company_id: "",
    company_name: '',
    address: '',
    bank_deposit: ''
  };


  componentDidUpdate(prevProps, prevState) {
    // eslint-disable-next-line
    if (prevProps.match.params.model === this.props.match.params.model) {
      return false;
    } else {
      // eslint-disable-next-line
      this.state.model = this.props.match.params.model;
      return true;
    }
  }

  _add() {
    this.setState({
      loading: true,
    });
    if (this.state.type === "普票") {
      if (
        !(getId("company_name") && this.state.company_id && this.state.type)
      ) {
        Toast.fail("* 必填项");
        this.setState({
          loading: false,
        });
        return;
      }
    } else {
      if (
        !(
          getId("company_name") &&
          this.state.company_id &&
          this.state.type &&
          getId("address") &&
          // getId("phone") &&
          getId("bank_deposit")
        )
      ) {
        this.setState({
          loading: false,
        });
        Toast.fail("必填项");
        return;
      }
    }

    if (!checkChineseP(getId("company_name"))) {
      Toast.fail("开票单位必须是中文或者括号");
      this.setState({
        loading: false,
      });
      return;
    }

    if (!CheckSocialCreditCodeOrg(this.state.company_id)) {
      Toast.fail("纳税识别号格式不对");
      this.setState({
        loading: false,
      });
      return;
    }

    if (getId("address").length > 100) {
      Toast.fail("地址最多100个字符");
      this.setState({
        loading: false,
      });
      return;
    }

    // if (getId("phone").length != 11) {

    //   Toast.fail("电话是11位");
    //   this.setState({
    //     loading: false,
    //   });
    //   return;
    // }

    let attachfiles = "";

    if (this.state.uploaedImages) {
      attachfiles = this.state.uploaedImages
        .map((obj, index) => {
          return obj.url;
        })
        .join(",");
    }

    request(
      "index/createInvoice",
      {
        uid: localStorage.getItem("openid"),
        // uid: "o3KXx5lSukpaX5Lwn_JRTiW5R_hk", // localStorage.getItem("openid"),
        type: this.state.type,
        company_name: getId("company_name"),
        company_id: this.state.company_id,
        // phone: getId("phone"),
        address: getId("address"),
        bank_deposit: getId("bank_deposit"),
        smallimages: attachfiles,
      },
      ({ data }) => {
        console.log(data);
        // eslint-disable-next-line
        if (data.code === 1) {
          // Toast.success("创建成功");
          setTimeout(() => {
            this.props.history.push("/fp/list");
          }, 500);
        } else {
          Toast.fail(data.msg);
        }
        this.setState({
          loading: false,
        });
      },
      (eror) => {
        this.setState({
          loading: false,
        });
        Toast.fail("创建失败");
      }
    );
  }

  sumbit() {
    return (
      <div
        style={{
          position: "fixed",
          height: "70px",
          left: 0,
          bottom: 0,
          right: 0,
          // backgroundColor: "rgb(51 51 51 / 14%)",
          display: "flex",
          maxWidth: "375px",
          margin: "auto",
        }}
      >
        <Button
          type="primary"
          style={{
            width: "88%",
            backgroundColor: "#AE5CC9",
            borderRadius: "23px",
            border: "1px solid #AE5CC9",
            margin: "auto",
          }}
          onClick={_.throttle(this._add.bind(this), 500)}
        >
          添加
        </Button>
      </div>
    );
  }

  type(e) {
    // console.log(e.target.value);
    // this.state.type = ;

    this.setState({
      type: e.target.value,
    });
  }

  bank_deposit(e) {
    console.log(e, "~~~");
    this.state.data.name = e;
    this.setState({
      data: this.state.data,
    });
  }

  main() {
    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div className={styles.info}>
            <div
              style={{ display: "flex" }}
              onChange={(e) => {
                this.type(e);
              }}
            >
              <input type="radio" name="type" value="普票" defaultChecked />
              <span className={selfStyles.pText}>普票</span>
              <input type="radio" name="type" value="专票" />
              <span className={selfStyles.pText}>专票</span>
            </div>

            <p className={selfStyles.text}>
              备注：如果开专票请提供开票详细信息和单位营业执照扫描件
            </p>
          </div>

          <div className={styles.info}>
            <div className={styles.head}>
              <span className={styles.title}>发票信息</span>
            </div>

            <Item
              left="* 开票单位"
              rightP="请输入开票单位"
              id="company_name"
              value={this.state.company_name}
              onChange={(e) => {
                this.setState({ 'company_name': e });
              }}
              onBlur={(e) => {
                let kaipiao = checkChineseP(this.state.company_name);
                if (!kaipiao) {
                  Toast.fail("开票单位只允许中文，最多五十个字符");
                  return;
                }
              }}
            ></Item>
            <Item
              left="* 纳税识别号"
              rightP="请输入纳税识别号,请注意大写"
              id="company_id"
              value={this.state.company_id}
              onChange={(e) => {
                this.setState({ 'company_id': e });
              }}
              onBlur={(e) => {
                let nashui = CheckSocialCreditCodeOrg(this.state.company_id);
                if (!nashui) {
                  Toast.fail("纳税识别号格式不对");
                  return;
                }
              }}
            ></Item>
          </div>

          <div
            className={styles.info}
            style={{
              display: this.state.type === "普票" && "none",
            }}
          >
            <div className={styles.head}>
              <span className={styles.title}>专票必填</span>
            </div>
            <Item
              left="* 地址、电话"
              rightP="请输入地址"
              id="address"
              value={this.state.address}
              onChange={(e) => {
                if (e.length < 100) {
                  this.setState({ 'address': e });
                }
              }}
              onBlur={(e) => {
                if (this.state.address.length > 100) {
                  Toast.fail("地址、电话最多100个字符");
                  return;
                }
              }}
            ></Item>
            {/* <Item
              left="* 电话"
              rightP="请输入电话"
              id="phone"
              value={this.state.phone}
              onChange={(e) => {
                if (e.length <= 11) {
                  this.setState({ 'phone': e });
                }
              }}
              onBlur={(e) => {
                if (this.state.phone.length != 11) {
                  Toast.fail("电话是11位的");
                  return;
                }
              }}
            ></Item> */}

            <Item
              left="* 开户行及账户"
              rightP="请输入开户行及账户"
              id="bank_deposit"
              value={this.state.bank_deposit}
              onChange={(e) => {
                this.setState({ 'bank_deposit': e });
              }}
              onBlur={(e) => {
                let kaipiao = checkChineseP(this.state.bank_deposit);
                if (!kaipiao) {
                  Toast.fail("开户行及账户只允许中文跟括号");
                  return;
                }
              }}
            ></Item>
            <div></div>
          </div>

          <div
            className={styles.info}
            style={{
              display: this.state.type === "普票" && "none",
            }}
          >
            <div className={styles.head}>
              <span className={styles.title}>上传附件</span>
              {/* <span className={styles.des}>此处可上传图片或PDF文件</span> */}
            </div>
            <div>
              <p
                style={{
                  marginTop: "0.3rem",
                  lineHeight: "1rem",
                  textAlign: "left",
                }}
              >
                该处可上传图片或PDF文件
              </p>
            </div>

            <div className={teststyles["upload-container"]}>
              <input
                type="file"
                name="image"
                className={teststyles["upload-input"]}
                onChange={async (e) => {
                  let file = e.target.files[0];
                  console.error("file", file);
                  if (!file) {
                    return;
                  }
                  this.setState({
                    loading: true,
                  });
                  if (this.state.uploaedImages.length < 1) {
                    let filename = checkFileName(file.name);
                    let res = 1;
                    this.state.uploaedImages.forEach((element) => {
                      if (element.filename === filename) {
                        Toast.fail("不得重复上传");
                        res = 0;
                        this.setState({
                          loading: false,
                        });
                      }
                    });

                    if (res) {
                      let res = await uploadOSS(file);
                      if (res.code === 1) {
                        let each = {
                          url: res.data.url,
                          filename: res.data.filename,
                          name: res.data.name,
                        };
                        this.state.uploaedImages.push(each);
                        this.setState();
                      }
                      this.setState({
                        loading: false,
                      });
                    }
                  } else {
                    this.setState({
                      loading: false,
                    });
                    Toast.fail("只能上传一个文件");
                  }
                }}
              />
              <Button type="primary">上传文件</Button>
            </div>

            <div className={styles.chusedImage}>
              {this.state.uploaedImages.map((item, index) => (
                <Img
                  item={item}
                  onClick={() => {
                    this.state.uploaedImages.splice(index, 1);
                    this.setState();
                  }}
                ></Img>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Header text="发票信息"></Header>
        {this.main()}
        {this.sumbit()}
        <div style={{ height: "80px", width: "100%" }}></div>
        <Loading loading={this.state.loading}></Loading>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FPAdd.js